<template>
  <div :class="['repeatableGroupReadOnly', definition.id, {'pulse': isLanguageSelected(object)}, {'w3-hide' : !aliasFoundOnPresentation() }, getRepeatableGroupPresentationAliasClass(definition.id)]">
    <label v-if="definition.type !== 'html' && definition.type !== 'image' && definition.type !== 'group'" :class="['label', {'hide':(getLabel(object) === null || getLabel(object) === '')}]">{{ getLabel(object) }}</label>
    <definition-text v-if="definition.type === 'text' || definition.type === 'longText'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :visualDefinition="visualDefinition"
      :apiparams="apiparams"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      @newLanguageSelected="newLanguageSelected"
    />
    <!-- comment for 'definition.js' low size -->
    <definition-html v-else-if="definition.type === 'html'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :tinyId="tinyId"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :authorization="authorization"
      :type="type"
      :visuals="visuals"
      :apiparams="apiparams"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :readOnly="true"
      @newLanguageSelected="newLanguageSelected"
    />
    <definition-image v-else-if="definition.type === 'image'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :authorization="authorization"
      :type="type"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :visuals="visuals"
      :apiparams="apiparams"
      @newLanguageSelected="newLanguageSelected"
    />
    <span v-else class="read-only" v-html="getObjectTextValue()" />

    <div v-if="object.children" v-for="(childObj, childObjIndex) in object.children" :key="childObjIndex">
      <definition-repeatable-group-read-only
        :definitionId="definitionId" :definition="getRequestDefinitionById(childObj)" :object="childObj"
        :languageSelected="languageSelected" :index="index" :moment="moment" :language="language" :visualDefinition="visualDefinition"
        :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
        :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :repeatableGroupPresentation="repeatableGroupPresentation" @newLanguageSelected="newLanguageSelected"
      />
    </div>
  </div>
</template>

<script>
import transport from 'vue-definition-utils/src/utils/transport'
import DefinitionHtml from '../html' // comment for 'definition.js' low size
import DefinitionText from '../text'
import DefinitionImage from '../image'

export default {
  name: 'definition-repeatable-group-read-only',
  props: [
    'definitionId',
    'definition',
    'object',
    'languageSelected',
    'index',
    'moment',
    'showMultilanguage',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'definitionContentId',
    'repeatableGroupCode',
    'repeatableGroupPresentation'
  ],
  components: {
    DefinitionHtml, // comment for 'definition.js' low size
    DefinitionText,
    DefinitionImage
  },
  data () {
    return {
      tinyId: null,
      languageChanged: false
    }
  },
  beforeMount () {
    if (this.definition.type === 'html' && this.index && this.moment) {
      this.tinyId = this.definition.id + '_' + this.index + '_' + this.moment
    } else {
      this.tinyId = this.definition.id
    }
  },
  methods: {
    getObjectTextValue () {
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      return transport.methods.getObjectTextValue(this.visualDefinition.definition, this.definition, this.object, languageSelectedKey)
    },
    getLabel (object) {
      var label = ''
      var reqDef = transport.methods.getRequestDefinitionById(object.id, [this.definition])
      if (reqDef) {
        label = this.definition.label
      }
      return label
    },
    getRequestDefinitionById (object) {
      var result = null
      if (object) {
        result = transport.methods.getRequestDefinitionById(object.id, [this.definition])
      }
      return result
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    isLanguageSelected (object) {
      var reqDef = this.getRequestDefinitionById(object)
      return transport.methods.isMultiLanguage(reqDef) && this.languageChanged
    },
    aliasFoundOnPresentation () {
      var result = true

      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.alias) {
        result = false
        for (var i = 0; i < this.repeatableGroupPresentation.alias.length && !result; i++) {
          result = (this.repeatableGroupPresentation.alias[i].id === this.definition.id)
        }
      }

      return result
    },
    getRepeatableGroupPresentationAliasClass (id) {
      var result = null

      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.alias) {
        for (var i = 0; i < this.repeatableGroupPresentation.alias.length && !result; i++) {
          if (this.repeatableGroupPresentation.alias[i].id === id) {
            result = this.repeatableGroupPresentation.alias[i].class
          }
        }
      }

      return result
    }
  },
  watch: {
    languageSelected (languageSelected) {
      this.languageChanged = true
      var self = this
      setTimeout(function () {
        self.languageChanged = false
      }, 550)
    }
  }
}
</script>

<style lang="scss">
.repeatableGroupReadOnly {
  padding: 2px 0 2px;

  .mce-toolbar,
  .mce-toolbar-grp,
  .mce-statusbar {
    display: none;
  }
  .mce-edit-area {
      border-width:0 0 0 !important;
  }
  .definition-wrapper {
    width: initial;
    display: inline;

    &.image {
      min-height: 438px !important;
      display: block;
    }
  }

  .image {
    img {
      width: 100%;
    }
  }

  &.marginTop {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/repeatableGroup/repeatableGroupReadOnly.vue